import {
  COMMON_LOAD_FILE_ASSOCIATIONS_BEGIN,
  COMMON_LOAD_FILE_ASSOCIATIONS_SUCCESS,
  COMMON_LOAD_FILE_ASSOCIATIONS_FAILURE,
  COMMON_LOAD_FILE_ASSOCIATIONS_DISMISS_ERROR
} from './constants'
import axios from 'axios'
import { FILES_ENDPOINT } from '../../../common/endpoints'

let requestCount = 0
let prevTime = Date.now()
let diffTime
let prevFileAssociations

// ad-hoc solution to avoid duplicate ongoing requests

export function createFileNewProductFromMaster({ id, endpointsList, isUsedCar }) {
  return async dispatch => {
    // optionally you can have getState as the second argument
    if (!id) {
      return null
    }
    dispatch({
      type: COMMON_LOAD_FILE_ASSOCIATIONS_BEGIN,
      data: {
        id: id
      }
    })

    try {
      let query=`?isUsedCar=${isUsedCar}&isFromProduct=true`
      const responseProduct = await axios(
        `${FILES_ENDPOINT}/${endpointsList.product}/${id}${query}`
      )
      const responseMaster = await axios(
        `${FILES_ENDPOINT}/${endpointsList.master}/${id}${query}`
      )

      dispatch({
        type: COMMON_LOAD_FILE_ASSOCIATIONS_SUCCESS,
        data: {
          fileAssociations: {
            [id]: [...responseProduct.data.data, ...responseMaster.data.data]
          }
        }
      })
    } catch (error) {
      dispatch({
        type: COMMON_LOAD_FILE_ASSOCIATIONS_FAILURE,
        data: { error }
      })
    }
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadFileAssociationsError() {
  return {
    type: COMMON_LOAD_FILE_ASSOCIATIONS_DISMISS_ERROR
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_LOAD_FILE_ASSOCIATIONS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fileAssociations: {
          ...state.fileAssociations,
          [action.data.id]: []
        },
        loadFileAssociationsPending: true,
        loadFileAssociationsError: null
      }

    case COMMON_LOAD_FILE_ASSOCIATIONS_SUCCESS:
      // limpiar cache de url de imagenes si son más de 50 y pasaron más de
      // 5 minutos entre peticiones
      requestCount += 1
      diffTime = Date.now() - prevTime > 1000 * 60 * 5
      prevFileAssociations = requestCount >= 49 && diffTime ? {} : state.fileAssociations
      if (requestCount >= 49 && diffTime) {
        requestCount = 0
      }
      // if cache > 50, clean cache
      prevTime = Date.now()
     
      return {
        ...state,
        loadFileAssociationsPending: false,
        loadFileAssociationsError: null,
        fileAssociations: {
          ...prevFileAssociations,
          ...action.data.fileAssociations
        }
      }

    case COMMON_LOAD_FILE_ASSOCIATIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        loadFileAssociationsPending: false,
        loadFileAssociationsError: action.data.error
      }

    case COMMON_LOAD_FILE_ASSOCIATIONS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadFileAssociationsError: null
      }

    default:
      return state
  }
}
